import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as result from '../result'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: result.RESOURCE.payload.dimension.partialId,
      partialId: result.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'success or failed for the latest deployment; null until the pull request is merged and deployed.',
    isOptional: true,
    name: 'Deploy Outcome',
    partialId: PartialId.Standard.create('deploy_outcome'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.deployOutcome.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
